import React from "react";
import { LANGUAGES } from "./translations";
import { useLang } from "./LanguageContext";

const LanguagePicker = () => {
  const { lang, changeLang, t } = useLang();

  return (
    <div className="picker">
      {/* <div className="picker__header">{t("selectLanguage")}</div> */}

      <div className="picker__grid">
        {LANGUAGES.map((l) => (
          <button
            type="button"
            key={l.code}
            className={`picker__item ${lang === l.code ? "is-active" : ""}`}
            onClick={() => changeLang(l.code)}
          >
            <span className="picker__icon" style={{ background: l.bg }}>
              {l.icon}
            </span>
            <span className="picker__text">
              <b>{l.native}</b>
              <small>{l.label}</small>
            </span>
            <span className="picker__radio" />
          </button>
        ))}
      </div>

      <div className="picker__hint">{t("clickAny")}</div>
    </div>
  );
};

export default LanguagePicker;
